import { FunctionComponent, ReactNode } from 'react';
import { StyledCell } from 'components/tables/cells/styles';
import { CellProps } from 'components/tables/cells';
import { VStack } from '@montel/montelpro-shared-components-v2';

export interface VerticalStackCellProps extends CellProps {
	children: ReactNode[];
}

const VerticalStackCell: FunctionComponent<VerticalStackCellProps> = ({
	align = 'flex-start',
	justify = 'center',
	offsetLeft,
	children,
}) => (
	<StyledCell
		align={align}
		justify={justify}
		$offsetLeft={offsetLeft}
		$height={children.length * 30}
	>
		<VStack>{children}</VStack>
	</StyledCell>
);

export default VerticalStackCell;
